import type { CustomizationMachineInput, Input } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const getFetchCustomizationDataInput: CustomizationMachineInput<Input> = (args) => {
  const {
    productSlug,
    restaurantSlug,
    ingredientAssetVersion,
    lineItemId,
    sharedLineItemId,
    isDelivery,
    isUpsellPricingEnabled,
  } = args.context;

  return {
    productSlug,
    restaurantSlug,
    ingredientAssetVersion,
    lineItemId,
    sharedLineItemId,
    isDelivery,
    isUpsellPricingEnabled,
  };
};
